import React from 'react';
import {
  Tooltip,
  IconButton as IconButtonCore,
  CircularProgress,
} from '@material-ui/core';
import {
  Visibility,
  Info,
  Edit,
  Tab,
  Receipt,
  Link,
  Close,
  Tune,
  CallMissed,
  CompareArrowsRounded,
  Check,
  Block,
  Search,
  DynamicFeed,
  Delete,
} from '@material-ui/icons';

const icons = {
  view: <Visibility />,
  info: <Info />,
  edit: <Edit />,
  delete: <Delete />,
  tab: <Tab />,
  receipt: <Receipt />,
  link: <Link />,
  close: <Close />,
  tune: <Tune />,
  callMissed: <CallMissed />,
  correctIcon: <CompareArrowsRounded />,
  affirmIcon: <Check />,
  cancel: <Block />,
  search: <Search />,
  closeTableModal: <Close style={{ color: '#f1f1f1' }} />,
  viewMore: <DynamicFeed />,
  circularProgress: (
    <CircularProgress style={{ color: '#1e7dff', height: 20, width: 20 }} />
  ),
  viewMore: <DynamicFeed />,
};

const IconButton = ({ icon, text, ...props }) => {
  return (
    <div>
      <Tooltip title={text} arrow>
        <div>
          <IconButtonCore aria-label={text} {...props}>
            {icons[icon]}
          </IconButtonCore>
        </div>
      </Tooltip>
    </div>
  );
};

export const IconButtons = ({ children }) => {
  return (
    <div style={{ display: 'flex', margin: 0, padding: 0 }}>{children}</div>
  );
};

export default IconButton;
